import { FluidImageProps } from '@vp/swan';

export class ZoomedDisplayData {
  constructor(
    private _image: string = '',
    private _altText: string = '',
    private _isZoomEnabled: boolean = false
  ) {}

  get isZoomEnabled(): boolean {
    return this._isZoomEnabled;
  }

  get imageProps(): FluidImageProps {
    return {
      src: this._image,
      alt: this._altText,
    };
  }
}
